var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.2
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47701 2 2.00001 6.477 2.00001 12C1.99649 14.3636 2.83331 16.6515 4.36101 18.455L3.14301 20.485C3.05186 20.6367 3.00261 20.8099 3.00029 20.9869C2.99797 21.1639 3.04266 21.3383 3.12981 21.4924C3.21696 21.6464 3.34343 21.7746 3.49631 21.8638C3.6492 21.953 3.82301 22 4.00001 22H12C12.3679 21.6667 12.8828 20.8 12 20H5.76601L6.46001 18.844C6.57403 18.6536 6.62147 18.4307 6.59485 18.2103C6.56824 17.99 6.46909 17.7848 6.31301 17.627C5.20259 16.5048 4.44901 15.0792 4.14716 13.5296C3.84531 11.98 4.00868 10.3758 4.6167 8.91888C5.22472 7.46197 6.25021 6.21751 7.56404 5.34221C8.87787 4.46692 10.4213 3.99991 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1572 7.84344 20 9.87827 20 12C20.3679 12.3333 21.2828 12.8 22 12C22 6.477 17.523 2 12 2Z",
    fill: "#10A37F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.596V20.798C17 21.2388 17.3574 21.596 17.798 21.596C18.2385 21.5958 18.5949 21.2385 18.5949 20.798V18.596H20.798C21.2385 18.5958 21.5949 18.2385 21.5949 17.798C21.5949 17.3575 21.2385 17.0002 20.798 17H18.5949V14.798C18.5949 14.3575 18.2385 14.0002 17.798 14C17.3574 14 17 14.3572 17 14.798V17H14.798C14.3574 17 14 17.3572 14 17.798C14 18.2388 14.3574 18.596 14.798 18.596H17Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddChat);
export default __webpack_public_path__ + "static/media/icon-add-chat.b6bfa4fa389067a9e2f39e2e9d250657.svg";
export { ForwardRef as ReactComponent };